import { CreditAccount, CreditAccountResponse } from '../types';
import { mapCreditPlan } from './creditPlanMapper';
import { creditTopUpDetailsMapper } from './creditTopUpDetailsMapper';

export const mapCreditAccount = (response: CreditAccountResponse): CreditAccount => {
  return {
    balance: response.balance,
    totalCredits: response.total_credits,
    allowOverages: response.allow_overages,
    creditsPlan: mapCreditPlan(response.credits_plan),
    topUpDetails: creditTopUpDetailsMapper(response.top_up_details),
    warningLevel: response.warning_level,
    usagePercentage: response.usage_percentage,
    monthlyUsageRate: response.monthly_usage_rate,
  };
};
